import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeWorkAccidentListService = (
  params: Types.EmployeeWorkAccidentListRequest
) =>
  RestAPIClient.call<Types.EmployeeWorkAccidentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeWorkAccidentCreateService = (
  params: Types.EmployeeWorkAccidentCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeWorkAccident>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeWorkAccidentUpdateService = ({
  id,
  ...rest
}: Types.EmployeeWorkAccidentUpdateRequest) =>
  RestAPIClient.call<Types.EmployeeWorkAccident>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Update.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const employeeWorkAccidentDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Delete.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });

export const employeeWorkAccidentDetailService = (id: string) =>
  RestAPIClient.call<Types.EmployeeWorkAccident>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });
